<template>
  <div class="demo-search">
    <div class="demo-panel-title">标准内容</div>
    <div class="demo-search-group">
      <h3 class="demo-title">搜索栏</h3>
      <div class="bx-search">
        <div class="bx-search-form">
          <i class="bx-search-icon bx-icon bx-icon-search"></i>
          <input v-model="key" class="bx-search-input" type="text" placeholder="搜索提示语" @focus="focus" @input="input"/>
          <a class="bx-search-clear bx-icon bx-icon-close-circle-surface" v-if="showDelete" @click="clear"></a>
        </div>
        <div class="bx-search-btn" v-if="showCancel" @click="cancel">取消</div>
      </div>
    </div>

    <div class="demo-panel-title">效果调试</div>
    <div class="demo-search-group">
      <h3 class="demo-title">搜索栏12px-16px</h3>
      <div class="bx-search">
        <input class="bx-input-test" type="text" placeholder="搜索提示语"/>
      </div>
    </div>
    <div class="demo-search-group">
      <h3 class="demo-title">搜索栏13px-17px</h3>
      <div class="bx-search">
        <input class="bx-input-test-13" type="text" placeholder="搜索提示语"/>
      </div>
    </div>
    <div class="demo-search-group">
      <h3 class="demo-title">搜索栏14px-20px</h3>
      <div class="bx-search">
        <input class="bx-input-test-14" type="text" placeholder="搜索提示语"/>
      </div>
    </div>
    <div class="demo-search-group">
      <h3 class="demo-title">搜索栏15px-21px</h3>
      <div class="bx-search">
        <input class="bx-input-test-15" type="text" placeholder="搜索提示语"/>
      </div>
    </div>
    <div class="demo-search-group">
      <h3 class="demo-title">搜索栏16px-22px</h3>
      <div class="bx-search">
        <input class="bx-input-test-16" type="text" placeholder="搜索提示语"/>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        key: '',
        showDelete: false,
        showCancel: false
      }
    },
    methods: {
      focus: function () {
        this.showCancel = true;
      },
      cancel: function () {
        this.showCancel = false;
      },
      input: function () {
        // eslint-disable-next-line
        this.showDelete = this.key ? true : false;
      },
      clear: function () {
        this.key = '';
      }
    }
  }
</script>
<style rel='stylesheet/less' lang="less">
  @import '../../../packages/style/base/mixin/form';

  .demo-search {
    background-color: #FFF;
    padding-bottom: 30px;
  }

  .bx-input-test {
    .input();
    .placeholder(12px);
    display: inline-block;
    width: 100%;
    height: 16px;
    line-height: 16px;
    border: 1px solid #000;
    font-size: 12px;
    color: #666;
  }

  .bx-input-test-13 {
    .input();
    .placeholder(13px);
    display: inline-block;
    width: 100%;
    height: 17px;
    line-height: 17px;
    border: 1px solid #000;
    font-size: 13px;
    color: #666;
  }

  .bx-input-test-14 {
    .input();
    .placeholder(14px);
    display: inline-block;
    width: 100%;
    height: 20px;
    line-height: 20px;
    border: 1px solid #000;
    font-size: 14px;
    color: #666;
  }

  .bx-input-test-15 {
    .input();
    .placeholder(15px);
    display: inline-block;
    width: 100%;
    height: 21px;
    line-height: 21px;
    border: 1px solid #000;
    font-size: 15px;
    color: #666;
  }

  .bx-input-test-16 {
    .input();
    .placeholder(16px);
    display: inline-block;
    width: 100%;
    height: 22px;
    line-height: 22px;
    border: 1px solid #000;
    font-size: 16px;
    color: #666;
  }

</style>



// WEBPACK FOOTER //
// src/views/ui/Search.vue